export default __webpack_public_path__ + "static/media/email_test_user_credential.4ec4de3e.png";